export default {
  props: ["links"],
  data: () => ({
    selectedMenu: null
  }),
  watch: {
    $route: {
      handler: function(data) {
        console.log("route changes", data);
        this.setSelectedMenu(data);
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    this.setSelectedMenu(this.$route.path);
  },
  methods: {
    setSelectedMenu(data) {
      const selected = this.links.find(item => item.link == data.path);
      console.log(selected);
      this.selectedMenu = selected;
    }
  }
};
